import Button from '@/shared/Button'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import FormInputBase from './FormInputBase'
import trim from 'lodash/trim'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useState } from 'react'

const MuiTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '3px',
    '& fieldset': { borderColor: theme.palette.secondary_80.main },
  },
}))

const FormTextField = ({
  itemProps = {},
  formProps = {},
  inputConfig = {},
  hideDefaultSearch,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword(show => !show)

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  const { t } = useTranslation()
  const {
    onSubmit,
    inputBaseProps,
    endAdornment,
    inputComponent,
    sx,
    afterTextField = () => null,
    ..._inputConfig
  } = inputConfig || {}
  const { field: { ref, onBlur, ...fieldProps } = {}, fieldState: { error } = {} } = formProps || {}

  const { disabled } = itemProps || {}
  const { label, type, ..._itemProps } = itemProps || {}

  const textFieldProps = {
    ..._inputConfig,
    ...fieldProps,
    ...otherProps,
    ..._itemProps,
  }

  const passwordType = showPassword ? 'text' : 'password'

  return (
    <FormInputBase
      label={label}
      onSubmit={
        onSubmit && !hideDefaultSearch
          ? () => {
              onSubmit(fieldProps.value)
            }
          : null
      }
      disabled={disabled}
      inputBaseProps={inputBaseProps}
    >
      <MuiTextField
        onKeyDown={e => {
          if (e.key.toLowerCase() === 'enter') {
            onSubmit?.()
          }
        }}
        inputRef={ref}
        size="small"
        helperText={error ? error.message : null}
        error={!!error}
        sx={{ flex: 1, ...sx }}
        onBlur={e => {
          fieldProps?.onChange?.(trim(e.target.value))
          onBlur?.(e)
        }}
        InputProps={{
          type: type === 'password' ? passwordType : type,
          endAdornment: (
            <>
              {endAdornment?.({ ...textFieldProps })}
              {onSubmit && hideDefaultSearch && (
                <Button
                  color={'secondary_80'}
                  sx={{
                    my: -8,
                    mr: '-8px',
                    border: theme => `1.5px solid ${theme.palette.secondary_80.main}`,
                    borderRadius: '0px 3px 3px 0px',
                  }}
                  onClick={() => {
                    onSubmit(fieldProps.value)
                  }}
                >
                  {t('general.search')}
                </Button>
              )}
              {type === 'password' && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}
            </>
          ),
          inputComponent,
        }}
        {...textFieldProps}
      />
      {afterTextField?.()}
    </FormInputBase>
  )
}

export default FormTextField
